import React, { useState, useEffect } from "react";
import { useAuth } from "../../../context/AuthContext";
import { getApiEndpoint } from "../../../config/config";
import { IconFlame } from "@tabler/icons-react";
import "./TrainingStreaks.css";

function TrainingStreaks() {
  const { getVerifiedJWT } = useAuth();
  const [streakData, setStreakData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStreaks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchStreaks = async () => {
    try {
      setLoading(true);
      const jwt = await getVerifiedJWT();
      if (!jwt) {
        setStreakData(null);
        return;
      }
      const response = await fetch(getApiEndpoint("/v1/training/streaks"), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch streak data");
      }

      const details = await response.json();
      setStreakData(details.data);
    } catch (err) {
      setStreakData(null);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="training-streaks-bubble-card training-streaks-bubble-card-wide training-streaks-placeholder-card">
        <div className="training-streaks-bubble-icon" />
        <div className="training-streaks-bubble-content training-streaks-placeholder-content">
          <span className="training-streaks-placeholder-line training-streaks-placeholder-line-md" />
        </div>
      </div>
    );
  }

  if (!streakData) {
    return (
      <div className="training-streaks-bubble-card training-streaks-bubble-card-wide">
        <div className="training-streaks-bubble-icon">
          <IconFlame size={20} />
        </div>
        <div className="training-streaks-bubble-content">
          <span className="training-streaks-bubble-label">
            Streak unavailable
          </span>
        </div>
      </div>
    );
  }

  // Determine which day is today (0 = Sunday, 6 = Saturday)
  const todayIndex = new Date().getDay();

  return (
    <div className="training-streaks-bubble-card training-streaks-bubble-card-wide">
      <div className="training-streaks-bubble-icon">
        <IconFlame
          size={20}
          className={streakData.accessed_today ? "active" : ""}
        />
      </div>
      <div className="training-streaks-bubble-content">
        <span className="training-streaks-bubble-label">
          {streakData.streak_days} day streak
        </span>
      </div>
      <div className="training-streaks-week-tracker">
        {(streakData.week || []).map((dayData, index) => {
          const isToday = index === todayIndex;
          return (
            <div
              key={index}
              className={`training-streaks-day ${isToday ? "today" : ""}`}
            >
              <span
                className={`training-streaks-circle ${
                  dayData.completed ? "completed" : ""
                } ${isToday ? "today" : ""}`}
              >
                {dayData.completed && (
                  <svg
                    className="training-streaks-check"
                    width="10"
                    height="10"
                    viewBox="0 0 12 12"
                    fill="none"
                  >
                    <path
                      d="M10 3L4.5 8.5L2 6"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
              </span>
              <span className="training-streaks-day-label">
                {dayData.weekday || ["S", "M", "T", "W", "T", "F", "S"][index]}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default TrainingStreaks;
